<div class="animated fadeIn fast">
  <div class="row row-margin row-check text-center">
    <img
      src="assets/images/pages/create-success.png"
      alt="Creación exitosa"
    />
  </div>
  <div class="row row-margin text-center">
    <p class="success-message">
      Se ha creado con
      <b class="primary">éxito la nueva cuenta,</b> con los siguientes datos.
    </p>
  </div>
  <div class="row text-center">
    <div class="col-md-3"></div>
    <div class="col-md-6 col-table text-center">
      <div class="row row-success-data">
        <div class="col-md-6 text-left">
          <span><b>RUC de la empresa</b></span>
        </div>
        <div class="col-md-6 text-right">
          <span>{{ _account.account.company.ruc }}</span>
        </div>
      </div>
      <div class="row row-success-data">
        <div class="col-md-6 text-left">
          <span><b>Nombre / Razón social</b></span>
        </div>
        <div class="col-md-6 text-right">
          <span>{{ _account.account.company.name }}</span>
        </div>
      </div>
      <div class="row row-success-data">
        <div class="col-md-6 text-left">
          <span><b>Tipo de documento</b></span>
        </div>
        <div class="col-md-6 text-right">
          <span>{{ _account.account.admin.docType }}</span>
        </div>
      </div>
      <div class="row row-success-data">
        <div class="col-md-6 text-left">
          <span><b>Número de documento</b></span>
        </div>
        <div class="col-md-6 text-right">
          <span>{{ _account.account.admin.docNumber }}</span>
        </div>
      </div>
      <div class="row row-success-data">
        <div class="col-md-6 text-left">
          <span><b>Nombre y apellido</b></span>
        </div>
        <div class="col-md-6 text-right">
          <span>{{ _account.account.admin.firstName + " " + _account.account.admin.lastName}}</span>
        </div>
      </div>
      <div class="row row-success-data">
        <div class="col-md-6 text-left">
          <span><b>Correo</b></span>
        </div>
        <div class="col-md-6 text-right">
          <span>{{ _account.account.admin.email }}</span>
        </div>
      </div>
    </div>
    <div class="col-md-3"></div>
  </div>
  <div class="row row-margin row-check">
    <button
      class="button-continue center-block"
      (click)="generateToken()"
    >
      Crear clave
    </button>
  </div>
</div>
